import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import {useSelector} from "react-redux"
import State from "../../ducks/state"
import Link from "../Link"
import {ImageWrapper} from "./component"

export type ProductImageProps = {
    description: string
    itemImageUrl?: string
    url: string
    itemNumber: string
    threeFourImageryEnabled: boolean
}

export type ImageProps = {
    alt: string
    src: string
    threeFourImageryEnabled: boolean
}

export const ProductImage = memo(
    ({itemImageUrl, url, description, itemNumber, threeFourImageryEnabled}: ProductImageProps) => {
        const template = useSelector((state: State) => state.template)

        const ComponentProductImage = useTemplatedComponent(template, MANIFEST)
        const img = (
            <ImageWrapper>
                <Suspense>
                    <ComponentProductImage
                        src={itemImageUrl}
                        alt={description}
                        threeFourImageryEnabled={threeFourImageryEnabled}
                    />
                </Suspense>
            </ImageWrapper>
        )
        let imageContainer = img
        if (url !== "") {
            imageContainer = (
                <Link href={`${url}#${itemNumber}`} alignTop>
                    {img}
                </Link>
            )
        }

        return imageContainer
    },
)
ProductImage.displayName = "ProductImage"

export default ProductImage
